import React from 'react';
import { Tabs, Icon } from 'antd';
import S from '../styles';
import { showCatAsList, formatDate } from './DataTable';
import '../Jobs.css';

const TabPane = Tabs.TabPane;

export const mainColumns = [
  {
    title: 'ID',
    dataIndex: 'id',
  },
  {
    title: 'Status',
    width: '80px',
    dataIndex: 'jobStatus',
  },
  {
    title: 'Categories',
    dataIndex: 'categories',
    width: '430px',
    render: showCatAsList,
  },
  {
    title: 'Date',
    dataIndex: 'dateBegin',
    width: '120px',
    render: formatDate,
  },
];

function DetailView(props) {
  return (
    <div style={S.detailView}>
      <h3 style={{ fontSize: '15px' }}>Job:  {props.jobId}</h3>
      <Icon type="close-circle" className="close-icon" onClick={() => { props.setShowDetail(0); props.setColumns(mainColumns); }} theme="filled" />
      <Tabs onChange={() => {}} type="card">
        <TabPane tab="Details" key="1">
          <p><span className="fieldLabel">Status:</span><span className="fieldData">{props.record.jobStatus}</span></p>
          <p><span className="fieldLabel">Create Date:</span><span className="fieldData">{formatDate(props.record.dateCreated)}</span></p>
          <p><span className="fieldLabel">Begin Date:</span><span className="fieldData">{formatDate(props.record.dateBegin)}</span></p>
          <p><span className="fieldLabel">End Date:</span><span className="fieldData">{formatDate(props.record.dateEnd)}</span></p>
          <p><span className="fieldLabel">Type:</span><span className="fieldData">{props.record.jobType}</span></p>
          <p><div className="longFieldLabel">Categories:</div><div className="longFieldData">{showCatAsList(props.record.categories)}</div></p>
        </TabPane>
        {/* <TabPane tab="Output Logs" key="2"> */}
        {/*    Content of Tab Pane 2 */}
        {/* </TabPane> */}
      </Tabs>
    </div>
  );
}

export default DetailView;
